










import { Mutations, Actions } from '@/ts/store/Constants';
import { Component, Vue } from 'vue-property-decorator';
import ImageData from '@/ts/ImageData';

@Component
export default class FullScreenImageViewer extends Vue {
    constructor() {
        super();
    }

    public swipeHandler() {
        this.$store.commit(Mutations.ADD_ACTIVE_FULLSCREEN_IMAGE, null);
        this.$store.commit(Mutations.IS_FULLSCREEN, false);
    }

    public goBack() {
        this.$store.commit(Mutations.ADD_ACTIVE_FULLSCREEN_IMAGE, null);
        this.$store.commit(Mutations.IS_FULLSCREEN, false);
    }

    get activeFullscreenImage(): string {
        return this.$store.getters['Images/getActiveFullScreenImage'];
    }

    get imageData(): ImageData {
        return this.$store.getters['Images/getImage'](this.activeFullscreenImage);
    }

    get dataLoaded(): boolean {
        return (this.imageData != null && this.imageData.hasData);
    }

    get optimalImageData(): string {
        if (this.imageData.originalData !== '') {
            return this.imageData.originalData;
        }

        if (this.imageData.largeData !== '') {
            return this.imageData.largeData;
        }

        this.$store.dispatch(Actions.FETCH_REMOTE_IMAGE_LARGE, this.imageData.guid);

        return this.imageData.thumbnailData;
    }
}
